import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import News from "@/pages/news/page";
import Characters from "@/pages/characters/page";
import Updates from "@/pages/updates/page";
import Detail from "@/pages/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "characters",
        element: <Characters />,
      },
      {
        path: "updates",
        element: <Updates />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;